import { useEffect, useState } from "react";
import Routes from "../routes";

const initialData = {
  state: [],
  group: [],
  company: [],
  country: [],
  manageRegion: [],
  notificationType: [],
  certificationType: [],
  leakDetectionMethod: [],
  weightUnit: [
    { id: "Kgs", name: "Kgs" },
    { id: "Lbs", name: "Lbs" },
  ],
  language: [
    {
      id: "en-US",
      name: "English",
    },
    {
      id: "es-ES",
      name: "Spanish",
    },
    {
      id: "fr-FR",
      name: "French",
    },
  ],
};

const useGetUserOptions = (userId) => {
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState(initialData);

  const fetchOptionData = async () => {
    try {
      setIsLoading(true);

      const requestGetUserDetailsDropDown = await fetch(
        Routes.User.GetUserDetailsDropDown(userId)
      );

      const response = await requestGetUserDetailsDropDown.json();

      const company = response.servicers.map(({ id, name }) => ({
        id,
        name,
      }));

      const leakDetectionMethod = response.leakDetectionMethods.map(
        ({ id, name }) => ({
          id,
          name,
        })
      );

      const notificationType = response.notificationTypes.map(
        ({ id, name }) => ({
          id,
          name,
        })
      );

      const certificationType = response.certificationTypes.map(
        ({ id, name }) => ({
          id,
          name,
        })
      );

      const group = response.groups.map(({ id, name }) => ({
        id,
        name,
      }));

      const country = response.countries.map(
        ({ countryCode, countryName }) => ({
          id: countryCode,
          name: countryName,
        })
      );

      const state = response.states.map(({ stateCode, stateName, countryCode }) => ({
        id: stateCode,
        name: stateName,
        countryCode
      }));

      const manageRegion = response.instanceAssociations.map(
        ({ id, name }) => ({
          id,
          name,
        })
      );
      
      setOptions({
        ...options,
        group,
        state,
        company,
        country,
        manageRegion,
        notificationType,
        certificationType,
        leakDetectionMethod,
      });
    } catch (error) {
      console.error("something went wrong with useGetUserOptions!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchOptionData();
  }, []);

  return {
    isLoading,
    options,
  };
};

export default useGetUserOptions;
